"use client"

import { useState } from "react"
import { HexColorPicker } from "react-colorful"
import {
  RibbonDivider,
  RibbonGroup,
  RibbonIconButton,
  RibbonToolbar,
} from "@/components/editor/ribbon/ribbon-primitives"
import { useRibbonActions } from "@/components/editor/ribbon/use-ribbon-actions"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"

const R = "/ribbion_menu"

export function DesignToolbar() {
  const actions = useRibbonActions()
  const [themeOpen, setThemeOpen] = useState(false)
  const [pageColorOpen, setPageColorOpen] = useState(false)
  const [themeColor, setThemeColor] = useState("#2563EB")
  const [pageColor, setPageColor] = useState("#FFFFFF")

  return (
    <RibbonToolbar>
      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/documentFormattingIcon.svg`}
          hoverHint={`${R}/documentFormattingHover.svg`}
          label="Document Formatting"
          onClick={actions.documentFormatting}
          iconClassName="brightness-110"
        />
        <Popover open={themeOpen} onOpenChange={setThemeOpen}>
          <PopoverTrigger asChild>
            <span>
              <RibbonIconButton
                icon={`${R}/themeColorIcon.svg`}
                hoverHint={`${R}/themeColorHover.svg`}
                label="Theme Colors"
              />
            </span>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-3" align="start">
            <HexColorPicker color={themeColor} onChange={setThemeColor} />
            <button
              type="button"
              className="mt-2 w-full rounded bg-[#2563EB] py-1.5 text-xs text-white"
              onClick={() => {
                actions.themeColor(themeColor)
                setThemeOpen(false)
              }}
            >
              Apply theme color
            </button>
          </PopoverContent>
        </Popover>
        <RibbonIconButton
          icon={`${R}/fontsIcon.svg`}
          hoverHint={`${R}/fontsHover.svg`}
          label="Font Themes"
          onClick={() => actions.fontTheme("TeX Gyre Termes")}
        />
        <RibbonIconButton
          icon={`${R}/effectIcon.svg`}
          hoverHint={`${R}/effectHover.svg`}
          label="Effects"
          onClick={actions.effects}
        />
      </RibbonGroup>

      <RibbonDivider />

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/watermarkIcon.svg`}
          hoverHint={`${R}/watermarkHover.svg`}
          label="Watermark"
          onClick={actions.watermark}
        />
        <Popover open={pageColorOpen} onOpenChange={setPageColorOpen}>
          <PopoverTrigger asChild>
            <span>
              <RibbonIconButton
                icon={`${R}/pageColorIcon.svg`}
                hoverHint={`${R}/pageColorHover.svg`}
                label="Page Color"
              />
            </span>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-3" align="start">
            <HexColorPicker color={pageColor} onChange={setPageColor} />
            <button
              type="button"
              className="mt-2 w-full rounded bg-[#2563EB] py-1.5 text-xs text-white"
              onClick={() => {
                actions.pageColor(pageColor)
                setPageColorOpen(false)
              }}
            >
              Apply page color
            </button>
          </PopoverContent>
        </Popover>
      </RibbonGroup>

      <RibbonDivider />

      <RibbonGroup>
        <RibbonIconButton
          icon={`${R}/pageEffectIcon.svg`}
          hoverHint={`${R}/pageEffectHover.svg`}
          label="Page Effects"
          onClick={actions.pageEffects}
        />
        <RibbonIconButton
          icon={`${R}/pageBorderIcon.svg`}
          hoverHint={`${R}/pageBorderHover.svg`}
          label="Page Border"
          onClick={actions.pageBorder}
        />
      </RibbonGroup>
    </RibbonToolbar>
  )
}
